import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = true

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import "vue-range-component/dist/vue-range-slider.css";
import VModal from 'vue-js-modal'
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

new Vue({
  render: h => h(App),
}).$mount('#app2')
